import React from "react";
import { useTranslation } from "react-i18next";

export const FailedMasterings = ({ items }) => {
  const { t } = useTranslation();
  if (!items?.length) return null;
  return (
    <div className="mt-6" data-testid="failed-masterings">
      <div className="text-[10px] tiny-caps text-[color:var(--fg-muted)] mb-2">
        {t("admin.failed_masterings_title", { count: items.length })}
      </div>
      <div className="rounded-lg border border-white/10 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-white/5 text-[10px] tiny-caps text-[color:var(--fg-muted)]">
            <tr>
              <th className="text-left px-4 py-2">Email</th>
              <th className="text-left px-4 py-2">{t("admin.failures_file")}</th>
              <th className="text-left px-4 py-2">{t("admin.failed_masterings_error")}</th>
              <th className="text-right px-4 py-2">{t("admin.failures_when")}</th>
            </tr>
          </thead>
          <tbody data-testid="failed-masterings-table">
            {items.map((row, idx) => (
              <tr key={`${row.analysis_id}-${idx}`} className="border-t border-white/5" data-testid={`failed-mastering-row-${idx}`}>
                <td className="px-4 py-2 text-white truncate max-w-[240px]">{row.email || "·"}</td>
                <td className="px-4 py-2 text-[color:var(--fg-secondary)] truncate max-w-[220px]">{row.filename || "·"}</td>
                <td className="px-4 py-2 text-red-300 text-xs truncate max-w-[280px]" title={row.error}>{row.error || "·"}</td>
                <td className="px-4 py-2 text-right text-xs text-[color:var(--fg-secondary)]">
                  {row.started_at ? new Date(row.started_at).toLocaleString() : "·"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
